import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const contentMaxWidth = 1366

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 'auto !important',
    maxWidth: contentMaxWidth,
    margin: 0,
    padding: '1rem 1.25rem',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.875rem',
    borderRadius: '0.5rem',
    boxShadow: '0 0 4px rgba(0, 0, 0, 0.1)',
  },

  tableBase: {
    width: '100%',
  },

  tableHeader: {
    '& th': {
      fontFamily: 'Nunito',
      fontWeight: '400',
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      textAlign: 'left',
      color: '#8B8D97',
      margin: 0,
      padding: 0,
    },
  },

  tableBody: {
    '& td': {
      fontFamily: 'Nunito',
      fontWeight: '400',
      fontSize: '1rem',
      lineHeight: '1.5rem',
      margin: 0,
      padding: 0,
    },
  },

  tableIcon: {
    marginTop: '-1rem',
    marginLeft: '-0.5rem',
    marginRight: '0.5rem',
    width: '5%',
  },

  tableName: {
    width: '40%',
    padding: '0.25rem 1rem',
  },

  tableUpdate: {
    width: '35%',
    padding: '0.25rem 1rem',
  },

  tableStatus: {
    width: '25%',
    padding: '0.25rem 1rem',
  },

  tableActions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: '-1rem',
    width: '20%',
    minWidth: '100px',
  },

  loading: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    width: '100%',
    height: '100%',
    gap: '2rem',
  },
}))

export { useStyles }
